import React from "react"

const ProgressBar = ({ completed }) => {
  const containerStyles = {
    height: 3,
    width: 100,
    backgroundColor: "#A9CBEE", // wave4-fix12: Ale blue family
    borderRadius: 2,
    margin: 50,
  }

  const fillerStyles = {
    height: "100%",
    width: `${completed}%`,
    backgroundColor: "white",
    opacity: 1,
    borderRadius: "inherit",
    textAlign: "right",
    transition: "width 1s ease-in",
  }

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}></div>
    </div>
  )
}

export default ProgressBar
